import styled from 'styled-components';

export const SHeader = styled.div`
  display: flex;
  margin: 20px;
  font-size: 20px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const SFlexCentered = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  border-top-left-radius: 8px;
  flex: 1;
  height: 90%;
  margin-left: 10px;
  min-width: 0;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  position: relative;

  &.global-search-result-wrapper {
    height: 100% !important;
  }

  .k-grid-container {
    overflow: hidden;
  }

  tr {
    white-space: nowrap;
  }

  .ml__kendo-grid {
    margin-left: 18px;
  }

  .ml__kendo-grid table:hover {
    border-top-left-radius: 0px;
  }

  .k-grid-header th.k-grid-header-sticky,
  .k-master-row.k-alt .k-grid-content-sticky,
  .k-grid-content-sticky {
    background-color: ${({ theme }) => theme.colors.quaternaryBackground};
    border: 0;
    border-radius: 0px;
    padding: 12px;
  }

  .k-grid table tr:hover .k-grid-header-sticky {
    color: inherit;
    background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  }

  .k-master-row:hover .k-grid-content-sticky,
  .k-master-row:hover .k-grid-row-sticky,
  .k-master-row.k-state-hover .k-grid-content-sticky,
  .k-master-row.k-state-hover .k-grid-row-sticky {
    background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  }
`;
